import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import mail from '../img/mail.svg'
import map from '../img/et_map.svg'
import phone from '../img/phone.svg'
import Fade from 'react-reveal/Fade';

const LinkArrow = () => (
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
    <path d="M4 1.00009L9 6.00009L4 11.0001M9.5 1L14.5 6L9.5 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const contactItems = [
  { icon: phone, titleKey: "footer.phone", content: "+81 90-7834-5778" },
  { icon: mail, titleKey: "footer.email", content: `support@${window.location.hostname}` },
  { icon: map, titleKey: "footer.liveChat", contentKey: "footer.liveChatText" },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#05193A] px-5 pb-12 pt-12 font-['Nunito_Sans'] text-white relative z-50">
      <div className="mx-auto max-w-[1220px]">
        <div className="grid gap-8 border-b border-[#14315d] pb-9 xl:grid-cols-3">
          {contactItems.map(({ icon, titleKey, content, contentKey }) => (
            <div key={titleKey} className="flex items-start gap-4">
              <div className="flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-[8px] bg-[#DAEBFC] text-[#05193A]">
                <img src={icon} alt={t(titleKey)} />
              </div>
              <div>
                <p className="text-[16px] font-semibold">{t(titleKey)}</p>
                <p className="mt-1 max-w-[240px] text-[16px] leading-5">{contentKey ? t(contentKey) : content}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid gap-8 pt-4 xl:grid-cols-[165px_155px_1fr]">
          <div>
            <h2 className="mb-3 text-[16px] font-semibold">{t("footer.documents")}</h2>
            <div className="flex flex-col gap-2 text-[16px]">
              <div className="flex items-center gap-[4px]"><LinkArrow /><a href="/docs/CONFLICT%20OF%20INTERESTS%20Nakamura.pdf">{t("footer.conflict")}</a></div>
              <div className="flex items-center gap-[4px]"><LinkArrow /><a href="/docs/Client%20agreement%20Nakamura.pdf">{t("footer.clientAgreement")}</a></div>
              <div className="flex items-center gap-[4px]"><LinkArrow /><a href="/docs/PRIVACY%20POLICY%20%20Nakamur.pdf">{t("footer.privacy")}</a></div>
            </div>
          </div>
          <div>
            <h2 className="mb-3 text-[16px] font-semibold">{t("footer.information")}</h2>
            <div className="flex flex-col gap-2 text-[16px]">
              <div className="flex items-center gap-[4px]"><LinkArrow /><Link to="/aboutus">{t("header.about")}</Link></div>
              <div className="flex items-center gap-[4px]"><LinkArrow /><Link to="/accounts">{t("header.accounts")}</Link></div>
              <div className="flex items-center gap-[4px]"><LinkArrow /><Link to="/markets">{t("header.markets")}</Link></div>
              <div className="flex items-center gap-[4px]"><LinkArrow /><Link to="/support">{t("header.support")}</Link></div>
            </div>
          </div>
          <div className="text-[12px] leading-[1.55]">
            <h2 className="mb-2 text-[16px] font-semibold">{t("footer.riskTitle")}</h2>
            <p>{t("footer.riskText")}</p>
            <h2 className="mb-2 mt-3 text-[16px] font-semibold">{t("footer.legalTitle")}</h2>
            <p>{t("footer.legalText")}</p>
            <p className="mt-2">{t("footer.copyright")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
